import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=1a36a24c&scoped=true&"
import script from "./Credential.vue?vue&type=script&lang=js&"
export * from "./Credential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36a24c",
  null
  
)

export default component.exports